import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(protected)/error.tsx");
